import React, { useState } from 'react';
import { Database, Filter, Info, ChevronDown, ExternalLink } from 'lucide-react';
interface DataVaultProps {
  userRole: 'Program Manager' | 'Founder';
}
const DataVault: React.FC<DataVaultProps> = ({
  userRole
}) => {
  const [activeFilter, setActiveFilter] = useState('all');
  return <div className="w-full px-6 pt-6" data-id="element-663">
      <h1 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-664">
        Kairos Program Shared Data
      </h1>
      <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mb-6 flex items-start" data-id="element-665">
        <Info size={16} className="text-blue-600 mr-2 mt-0.5" data-id="element-666" />
        <div data-id="element-667">
          <p className="text-sm text-blue-800 font-medium" data-id="element-668">
            Anonymized from cohort submissions; identifiers removed.
          </p>
        </div>
      </div>
      {/* Filters */}
      <div className="flex space-x-3 mb-6" data-id="element-669">
        <div className="relative" data-id="element-670">
          <button className="px-4 py-2 bg-white border border-gray-300 rounded-md flex items-center text-sm text-gray-700" data-id="element-671">
            <Filter size={14} className="mr-2 text-gray-500" data-id="element-672" />
            Area: Cardiology
            <ChevronDown size={14} className="ml-2 text-gray-500" data-id="element-673" />
          </button>
        </div>
        <div className="relative" data-id="element-674">
          <button className="px-4 py-2 bg-white border border-gray-300 rounded-md flex items-center text-sm text-gray-700" data-id="element-675">
            Stage: Discovery
            <ChevronDown size={14} className="ml-2 text-gray-500" data-id="element-676" />
          </button>
        </div>
        <div className="relative" data-id="element-677">
          <button className="px-4 py-2 bg-white border border-gray-300 rounded-md flex items-center text-sm text-gray-700" data-id="element-678">
            Cohort: Cohort 1
            <ChevronDown size={14} className="ml-2 text-gray-500" data-id="element-679" />
          </button>
        </div>
      </div>
      {/* Benchmark Tiles */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-680">
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-681">
          <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-682">
            Avg interviews to problem validation
          </h3>
          <div className="flex items-end justify-between" data-id="element-683">
            <span className="text-xl font-semibold text-gray-800" data-id="element-684">8.2</span>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-685">
          <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-686">
            Top objections (Cardiology)
          </h3>
          <div className="flex items-end justify-between" data-id="element-687">
            <div className="flex space-x-2" data-id="element-688">
              <span className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full" data-id="element-689">
                Transportation
              </span>
              <span className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full" data-id="element-690">
                Work schedule
              </span>
              <span className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full" data-id="element-691">
                Co-pays
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200" data-id="element-692">
          <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-693">
            Insight quality score
          </h3>
          <div className="flex items-end justify-between" data-id="element-694">
            <span className="text-xl font-semibold text-gray-800" data-id="element-695">7.6/10</span>
            <span className="text-xs text-gray-500" data-id="element-696">(studio heuristic)</span>
          </div>
        </div>
      </div>
      {/* Anonymized Insight Cards */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-697">
        <div className="border-b border-gray-200 p-4" data-id="element-698">
          <h2 className="text-lg font-medium text-gray-800" data-id="element-699">
            Anonymized Insights
          </h2>
        </div>
        <div className="p-4 border-b border-gray-200" data-id="element-700">
          <div className="flex justify-between mb-1" data-id="element-701">
            <h3 className="font-medium text-gray-800" data-id="element-702">
              Transportation barriers peak in weeks 2–3
            </h3>
            <span className="text-xs py-0.5 px-2 bg-green-100 text-green-800 rounded-full" data-id="element-703">
              High Confidence
            </span>
          </div>
          <p className="text-sm text-gray-600 mb-3" data-id="element-704">
            Patient no-shows increase significantly in weeks 2–3 of cardiac
            rehab, with transportation cited as the primary barrier. Early
            identification and intervention could improve adherence rates.
          </p>
          <div className="flex justify-between items-center" data-id="element-705">
            <div className="flex items-center text-xs text-gray-500" data-id="element-706">
              <span className="mr-2" data-id="element-707">Source: Cohort 1, Cardiology</span>
              <button className="text-blue-600 hover:text-blue-800 flex items-center" data-id="element-708">
                View anonymization details{' '}
                <ExternalLink size={12} className="ml-1" data-id="element-709" />
              </button>
            </div>
            <div className="flex items-center" data-id="element-710">
              <Database size={14} className="text-gray-400 mr-1" data-id="element-711" />
              <span className="text-xs text-gray-500" data-id="element-712">Added 1 hour ago</span>
            </div>
          </div>
        </div>
        <div className="p-4 border-b border-gray-200" data-id="element-713">
          <div className="flex justify-between mb-1" data-id="element-714">
            <h3 className="font-medium text-gray-800" data-id="element-715">
              Human calls reduce no-shows by ~15 points vs automated texts
            </h3>
            <span className="text-xs py-0.5 px-2 bg-green-100 text-green-800 rounded-full" data-id="element-716">
              High Confidence
            </span>
          </div>
          <p className="text-sm text-gray-600 mb-3" data-id="element-717">
            Personal phone call reminders outperform automated text messages by
            approximately 15 percentage points in reducing cardiac rehab
            no-shows, especially for patients 65+.
          </p>
          <div className="flex justify-between items-center" data-id="element-718">
            <div className="flex items-center text-xs text-gray-500" data-id="element-719">
              <span className="mr-2" data-id="element-720">Source: Cohort 1, Cardiology</span>
              <button className="text-blue-600 hover:text-blue-800 flex items-center" data-id="element-721">
                View anonymization details{' '}
                <ExternalLink size={12} className="ml-1" data-id="element-722" />
              </button>
            </div>
            <div className="flex items-center" data-id="element-723">
              <Database size={14} className="text-gray-400 mr-1" data-id="element-724" />
              <span className="text-xs text-gray-500" data-id="element-725">Added 1 hour ago</span>
            </div>
          </div>
        </div>
        <div className="p-4" data-id="element-726">
          <div className="flex justify-between mb-1" data-id="element-727">
            <h3 className="font-medium text-gray-800" data-id="element-728">
              Misunderstood cadence makes sessions feel optional; reinforce plan
            </h3>
            <span className="text-xs py-0.5 px-2 bg-yellow-100 text-yellow-800 rounded-full" data-id="element-729">
              Medium Confidence
            </span>
          </div>
          <p className="text-sm text-gray-600 mb-3" data-id="element-730">
            Patients often misinterpret cardiac rehab session cadence as
            optional rather than prescribed. Clearly reinforcing the
            insurance-authorized plan at discharge and in week one could improve
            adherence.
          </p>
          <div className="flex justify-between items-center" data-id="element-731">
            <div className="flex items-center text-xs text-gray-500" data-id="element-732">
              <span className="mr-2" data-id="element-733">Source: Cohort 1, Cardiology</span>
              <button className="text-blue-600 hover:text-blue-800 flex items-center" data-id="element-734">
                View anonymization details{' '}
                <ExternalLink size={12} className="ml-1" data-id="element-735" />
              </button>
            </div>
            <div className="flex items-center" data-id="element-736">
              <Database size={14} className="text-gray-400 mr-1" data-id="element-737" />
              <span className="text-xs text-gray-500" data-id="element-738">Added 1 hour ago</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default DataVault;